import { render, staticRenderFns } from "./PlantForm.vue?vue&type=template&id=5f49dc20&scoped=true"
import script from "./PlantForm.vue?vue&type=script&lang=ts"
export * from "./PlantForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f49dc20",
  null
  
)

export default component.exports